import { LocalStorageKey } from '@/constants/localstorage'
import { Center, Icon } from '@chakra-ui/react'
import { useLocalStorage } from 'usehooks-ts'
import { WithClient } from '@/components/HOC/WithClient'
import VolumeIcon from '@/public/assets/icons/volume.svg'
import VolumeMuteIcon from '@/public/assets/icons/volume-mute.svg'
import { useRouter } from 'next/router'

export const AudioSwitch = () => {
  const router = useRouter()
  const [audio, setAudio] = useLocalStorage(LocalStorageKey.Audio, true)
  const isGameZone = router.pathname.startsWith('/game-zone')
  return (
    <Center
      bg={'ninja.600'}
      cursor="pointer"
      transition={'0.1s'}
      _hover={isGameZone ? {} : { bg: 'ninja.500', color: 'ninja.100' }}
      onClick={() => !isGameZone && setAudio(!audio)}
      h={12}
      w={12}
      rounded="2xl"
      color={'ninja.200'}
      opacity={isGameZone ? 0 : 1}
    >
      <WithClient fallback={() => <Icon boxSize={6} as={VolumeIcon} />}>
        <Icon boxSize={6} as={audio ? VolumeIcon : VolumeMuteIcon} />
      </WithClient>
    </Center>
  )
}
